import { Component, Input } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { FormState, NgrxFormsModule } from 'ngrx-forms';
import { NgTemplateOutlet } from '@angular/common';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TrackValueChangeDirective } from '@analytics/events';
import { ValidationClassesDirective } from '@innogy/utils-deprecated';

@Component({
  selector: 'wl-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    NgTemplateOutlet,
    NgrxFormsModule,
    AutomationIdDirective,
    ValidationClassesDirective,
    AutomationIdDirective,
    TrackValueChangeDirective,
  ],
})
export class DateInputComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() placeholder = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() label = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() fieldName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) formsControl!: FormState<string>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: ComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() stepName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() step?: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() sendValue? = true;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() skipDirtyCheck = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() labelFloating = true;
}
